var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-sticky',[_c('van-row',{staticClass:"headpro"},[_c('van-col',{attrs:{"span":"24"}},[_vm._v(" "+_vm._s(_vm.$t('prolist.pagetitle'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }